import { observer } from 'mobx-react-lite';
import * as React from 'react';

import './button-switch.css';

interface IProps {
    value: string;
    options: { [key: string]: IOption };
    onChange(value: string): void;
}

export interface IOption {
    value: string;
    display: React.ReactNode;
    disabled?: boolean;
}

export const ButtonSwitch = observer((props: IProps) => {
    const onChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const target = event.target;
        const value = target.value;

        props.onChange(value);
    }, [props]);

    const renderOptions = () => {
        const options = [];
        for (const option of Object.keys(props.options)) {
            const item = props.options[option];
            options.push((
                <label className={`btn-switch-item ${option === props.value ? 'active' : ''}`} key={option}>
                    <input type='radio' name='switch-btn' onChange={onChange} value={option} />
                    {item.display}
                </label>
            ));
        }
        return options;
    };

    return (
        <div className='btn-switch'>
            {renderOptions()}
        </div>
    );
});